import { useTranslation } from 'react-i18next';

import { Stack, Typography } from '@mui/material';

import { colors } from '../../utils/colors';
import { GradientCircularProgress } from './GradientCircularProgress';

export const GenerationInProgressMessage = () => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      flexBasis="100%"
      justifyContent="center"
      sx={{ px: 4, py: 2, background: colors.custom.bgGrey, borderRadius: '6px' }}
    >
      <GradientCircularProgress size={24} />
      <Typography sx={{ color: colors.text.secondary }}>
        {t('app.labels.generationInProgress')}
      </Typography>
    </Stack>
  );
};
